import { zodResolver } from '@hookform/resolvers/zod'
import { z } from 'zod'
import { l } from '@manychat/manyui'

import { KnowledgeValidation } from 'apps/aiAutomation/components/KnowledgeEditor/lib/validation'

export const ENTRY_MAX_SIZE = 250000

export const knowledgeEntryResolver = zodResolver(
  z.object({
    text: z
      .string()
      .trim()
      .min(5, l.translate('Provide more knowledge to continue'))
      .superRefine((entryContent, ctx) => {
        if (entryContent.length > ENTRY_MAX_SIZE) {
          ctx.addIssue({
            code: 'custom',
            message: l.translate(
              'You’ve exceeded the limit — remove {count, plural, one {# character} other {# characters}}',
              {
                count: entryContent.length - ENTRY_MAX_SIZE,
              },
            ),
          })
        }
      }),
    title: KnowledgeValidation.getTitleSchema(),
  }),
)
